<template>
  <v-dialog v-model="isOpenFile" persistent max-width="440px">
    <div class="position-relative">
      <v-card>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('shipping_instruction.file_name_list') }}</h5>
          <button type="button" class="close" data-dismiss="modal" @click="close">
            &times;
          </button>
        </div>
        <v-card-text>
          <div v-for="(file, i) in files" :key="i" class="level">
            <div class="file">
              <p class="limit-display-text">{{file['name']}}</p>
              <button
                style="background-color: #e0e0e0;width: 25px; border-radius: 9px;"
                type="button"
                class="delete-file"
                @click="deleteFile(i)"
              >
                x
              </button>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <loading-component :is-loading="isLoading"/>
    </div>
  </v-dialog>
</template>

<script>
import LoadingComponent from './loading/LoadingComponent.vue'
import _isEmpty from 'lodash/isEmpty'
import { mapState } from 'vuex'

export default {
  name: 'ShippingFilesModal',
  props: {
    isOpenFile: {
      type: Boolean,
      default: false
    },
    masterFile: {
    }
  },
  components: {
    LoadingComponent
  },
  watch: {
    masterFile: {
      handler: function (val) {
        if (!_isEmpty(val)) {
          this.files = val
        }
      },
      deep: true
    }
  },
  data () {
    return {
      isLoading: false,
      files: '',
      file: []
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    deleteFile (index) {
      this.files.splice(index, 1)
    },
    close () {
      this.$emit('close', false)
    }
  }
}
</script>

<style scoped>

.position-relative {
  position: relative;
}
.limit-display-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 360px;
}
.file {
  margin: 0;
  padding: 0;
  position: relative;
}
.delete-file {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 15px;
  font-weight: bold;
}
</style>
